import { render, staticRenderFns } from "./RealGrid.vue?vue&type=template&id=4c43f44b"
import script from "./RealGrid.vue?vue&type=script&lang=js"
export * from "./RealGrid.vue?vue&type=script&lang=js"
import style0 from "./RealGrid.vue?vue&type=style&index=0&id=4c43f44b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports